import ApiClient from '@/helpers/api-client/ApiClient';
import store from '@/store';
import { UserRoles } from '@/enums/UserRoles';

export default function redirect ({ next }) {
  if (isAuthenticated() && allowedUserRole()) {
    return next('/application/vts/create')
  }

  window.location.replace(ApiClient.getAccountUrl())
}

function isAuthenticated () {
  return !!store.getters.user;
}

function allowedUserRole () {
  return store?.getters?.user?.role === UserRoles.TRUSTED_USER;
}
